
export default {
  name: 'TrajectoryCard',

  props: {
    title: {
      type: String,
      required: true
    },

    isSelected: {
      type: Boolean,
      required: true
    }
  }
}
